import { IAccessServices } from 'services/RawData/access_services';
import accessWebPage from '.';

export const createAccessPage = (accessServices: IAccessServices) => {
  return accessWebPage(accessServices);
};
